import { GroupedBalancesPerCategoryInfoModel } from 'api/models.v2';

type BalancesByTypeProps = {
  expenses: GroupedBalancesPerCategoryInfoModel;
  revenues: GroupedBalancesPerCategoryInfoModel;
  all: GroupedBalancesPerCategoryInfoModel;
  isResident?: boolean;
};

type BalanceProps = GroupedBalancesPerCategoryInfoModel & {
  // Optional because the `all` bucket is pushed through unnamed — only the
  // revenue and expense buckets are given a name. `month-summary` renders the
  // name behind `!isResident`, and `all` is only ever pushed for residents, so
  // no caller reads a name that is not there.
  name?: string;
  hideSplitIt?: boolean;
};

export function getBalancesByType({
  expenses,
  revenues,
  all,
  isResident,
}: BalancesByTypeProps): BalanceProps[] {
  const balances = [];
  if (isResident && !!all) {
    balances.push(all);
  }

  if (revenues) {
    balances.push({ ...revenues, name: 'Revenue', hideSplitIt: true });
  }

  if (expenses) {
    balances.push({ ...expenses, name: 'Expenses' });
  }

  return balances;
}
